import { AnnounceSurveySharing } from './components/AnnounceSurveySharing';
import { PromoteContributorSeats } from './components/PromoteContributorSeats';
import { ModuleNameToModuleRegistry } from '../../types/types';

const informationModals: Readonly<ModuleNameToModuleRegistry> = Object.freeze({
  announce_survey_sharing_popup: AnnounceSurveySharing,
  promote_contributor_seats_popup: PromoteContributorSeats,
});

export default informationModals;
